import React from 'react';

interface DateGuardProps {
    children: React.ReactNode;
}

export default function DateGuard({ children }: DateGuardProps) {
    return <>{children}</>;
}
